/**
 * Query keys for the signed-in account (`../core/keys.ts` is the convention).
 *
 * `["me"]` is its own domain rather than a profile sub-key: it is the IAM
 * account (`/auth/me`), not the athlete, and a locale write must refetch it
 * without refetching any training section.
 */
export const meKeys = {
    all: ["me"],
    account: ["me", "account"],
};
//# sourceMappingURL=keys.js.map